/* INMORIES 幣別顯示換算：依即時匯率只改顯示，結帳仍以 TWD 計價 */
(function () {
  var CFG = window.INM_CURRENCY || {};
  var KEY = 'inm_currency';
  var RATE_KEY = 'inm_rates_twd_v1';
  var RATE_URL = 'https://open.er-api.com/v6/latest/TWD';
  var TTL = 60 * 60 * 1000; // 匯率快取 1 小時
  var symbols = CFG.symbols || {};
  var zeroDec = CFG.zeroDecimals || {};
  var rates = null;
  var current = 'TWD';
  var rendering = false;

  function safeGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function safeSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function loadRates() {
    var cached = safeGet(RATE_KEY);
    if (cached) {
      try {
        var c = JSON.parse(cached);
        if (c && c.t && Date.now() - c.t < TTL && c.rates) { rates = c.rates; return Promise.resolve(rates); }
      } catch (e) {}
    }
    return fetch(RATE_URL).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.result === 'success' && j.rates) {
        rates = j.rates;
        safeSet(RATE_KEY, JSON.stringify({ t: Date.now(), rates: rates }));
      }
      return rates;
    }).catch(function () { return rates; });
  }

  function parseAmount(text) {
    var m = String(text).replace(/,/g, '').match(/-?\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }

  function format(amount, code) {
    var dec = zeroDec[code] ? 0 : 2;
    var parts = amount.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (symbols[code] || code + ' ') + parts.join('.');
  }

  function convertAll() {
    rendering = true;
    var els = document.querySelectorAll('.cvc-money');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.hasAttribute('data-inm-orig') || el.getAttribute('data-inm-rendered') !== el.textContent) {
        el.setAttribute('data-inm-orig', el.textContent);
        el.setAttribute('data-inm-twd', parseAmount(el.textContent));
      }
      var twd = parseFloat(el.getAttribute('data-inm-twd'));
      var out;
      if (current === 'TWD' || !rates || !rates[current] || isNaN(twd)) {
        out = el.getAttribute('data-inm-orig');
      } else {
        out = format(twd * rates[current], current);
      }
      if (el.textContent !== out) el.textContent = out;
      el.setAttribute('data-inm-rendered', out);
    }
    updateNotes();
    updateToggle();
    rendering = false;
  }

  function updateNotes() {
    var show = current !== 'TWD' && rates && rates[current];
    var targets = [];
    var pp = document.querySelector('.product-single__meta .price');
    if (pp) targets.push(pp);
    var cs = document.querySelector('.cart-subtotal');
    if (cs) targets.push(cs);
    targets.forEach(function (t) {
      var note = null;
      var sib = t.nextElementSibling;
      if (sib && sib.classList.contains('inm-currency-note')) note = sib;
      if (show) {
        if (!note) {
          note = document.createElement('p');
          note.className = 'inm-currency-note';
          note.textContent = CFG.note || 'Checkout is charged in TWD.';
          t.parentNode.insertBefore(note, t.nextSibling);
        }
      } else if (note) {
        note.parentNode.removeChild(note);
      }
    });
  }

  function updateToggle() {
    var btn = document.querySelector('[data-inm-currency-toggle]');
    if (btn) btn.textContent = current + ' ' + (symbols[current] || '');
    var opts = document.querySelectorAll('[data-inm-currency-option]');
    for (var i = 0; i < opts.length; i++) {
      var li = opts[i].parentNode;
      if (opts[i].getAttribute('data-value') === current) {
        li.classList.add('disclosure-list__item--current');
        opts[i].setAttribute('aria-current', 'true');
      } else {
        li.classList.remove('disclosure-list__item--current');
        opts[i].removeAttribute('aria-current');
      }
    }
  }

  function setCurrency(code) {
    current = code;
    safeSet(KEY, code);
    if (code !== 'TWD' && !rates) loadRates().then(convertAll); else convertAll();
  }

  function initSwitcher() {
    var root = document.querySelector('[data-inm-currency]');
    if (!root) return;
    var btn = root.querySelector('[data-inm-currency-toggle]');
    var list = root.querySelector('[data-inm-currency-list]');
    if (!list) return;
    function close() {
      if (!btn) return;
      list.classList.remove('disclosure-list--visible');
      btn.setAttribute('aria-expanded', 'false');
    }
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = list.classList.toggle('disclosure-list--visible');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
    list.addEventListener('click', function (e) {
      var a = e.target.closest('[data-inm-currency-option]');
      if (!a) return;
      e.preventDefault();
      setCurrency(a.getAttribute('data-value'));
      close();
      document.dispatchEvent(new CustomEvent('inm:currency-selected'));
    });
  }

  // 頁首右上角的語言／幣別面板
  function initHeaderPanel() {
    var root = document.querySelector('[data-inm-lc]');
    if (!root) return;
    var btn = root.querySelector('[data-inm-lc-toggle]');
    var panel = root.querySelector('[data-inm-lc-panel]');
    if (!btn || !panel) return;
    function close() { panel.classList.remove('inm-lc__panel--open'); btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var open = panel.classList.toggle('inm-lc__panel--open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('inm:currency-selected', close);
    root.addEventListener('click', function (e) {
      var l = e.target.closest('[data-inm-lc-locale]');
      if (!l) return;
      e.preventDefault();
      if (l.hasAttribute('aria-current')) { close(); return; }
      var form = root.querySelector('#inm-lc-localization');
      var input = form && form.querySelector('[data-inm-lc-locale-input]');
      if (!form || !input) return;
      input.value = l.getAttribute('data-inm-lc-locale');
      form.submit();
    });
  }

  function observe() {
    var timer = null;
    var mo = new MutationObserver(function () {
      if (rendering) return;
      clearTimeout(timer);
      timer = setTimeout(convertAll, 60);
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function start() {
    current = safeGet(KEY) || CFG.defaultCurrency || 'TWD';
    initSwitcher();
    initHeaderPanel();
    updateToggle();
    convertAll();
    loadRates().then(function () { if (current !== 'TWD') convertAll(); });
    observe();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
